<template>
    <div class="sso-callback">
        <h2 class="sso-callback__title" v-html="$t('Login.log_in_sso-callback-title')"></h2>
        <span class="sso-callback__instructions" v-html="$t('Login.log_in_sso-callback-instructions')"></span>
        <span v-if="isProcessingSSORequest" class="sso-callback__login-spinner spinner icon-spinner"></span>
        <div v-if="error" class="sso-callback__error">
            <span class="sso-callback__error-icon icon-notification"></span>
            <span v-html="error"></span>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'SSOLoginDedicated',
        data () {
            return {
                isProcessingSSOLogin: false,
                error: null
            }
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn',
            }),
            providerId () {
                    return this.$route.params.serviceId ?? 'microsoft'
                }
        },
        watch: {
            isLoggedIn: {
                handler (logged) {
                    if (logged) {
                        this.$router.push({ name: 'home' })
                    }
                },
                immediate: true
            }
        },
        methods: {
            async requestSSOLogin () {
                this.error = null
                try {
                    this.isProcessingSSORequest = true
                    this.SSOLoginUrl = await this.$store.dispatch('requestSSOLoginUrl', this.providerId)
                    location.assign(this.SSOLoginUrl)
                } catch (e) {
                    this.error = this.$t('Login.log_in_sso-general-error')
                    this.isProcessingSSORequest = false
                }
            }
        },
        created () {
            this.requestSSOLogin()
        }
    }
</script>

<style lang="scss" scoped>
    .sso-callback {
        padding: 240px 0;
        display: flex;
        flex-direction: column;

        &__title {
            margin: 0 auto;
            padding: 0 0 10px 0;
            font-size: 3rem;
        }
        &__instructions {
            margin: 0 auto;
            padding: 0 0 20px 0;
            font-size: 1.8rem;
            max-width: 700px;
            text-align: center;
        }
        &__login-spinner {
            margin: 0 auto;
            padding: 0 0 20px 0;
            font-size: 3rem;
            color: $black;
        }
        &__error {
            color: red;
            margin: 0 auto;
            font-size: 2rem;
            font-family: Nunito-Bold, sans-serif;
        }
        &__error-icon {
            margin: 10px;
        }
    }
</style>
